<template>
  <j-modal
    :title="title"
    width="25%"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    @ok="handleOk"
    @cancel="handleCancel"
    :okText="$t('确定')"
    :cancelText="$t('关闭')"
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
  >
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="disableSubmit">
        <a-form-model
          ref="form"
          :model="model"
          :rules="validatorRules"
          slot="detail"
          :colon="true"
          layout="horizontal"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-row :gutter="24">
            <a-col :span="24" v-for="(value, key, index) in model" :key="index">
              <a-form-model-item :label="setLabel(key)" :prop="key" v-if="setIsShow(key)">
                <j-dict-select-tag :showSearch="false" v-model="model[key]" :placeholder="$t('请选择类型')" :disabled="setDisabled(key)" dictCode="node_type" v-if="key == 'type'"></j-dict-select-tag>
                <a-input v-model="model[key]" :placeholder="$t('请输入')" :disabled="setDisabled(key)" v-else></a-input>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </j-modal>
</template>
    
    <script>
import { httpAction, getAction, postAction } from '@/api/manage'
import { validateDuplicateValue } from '@/utils/util'
export default {
  name: 'modal',
  components: {},
  data() {
    return {
      title: this.$t('管道属性编辑'),
      width: 800,
      visible: false,
      disableSubmit: false,
      confirmLoading: false,
      model: {},
      validatorRules: {},
      url: {
        getPipelineByCode: '/jeecg-gis/topology/pipeline/getPipelineByCode',
        updatePipeline: "/jeecg-gis/topology/pipeline/updatePipeline"
      },
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    }
  },
  computed: {
    // 字段映射字典（中文标签）
    fieldLabels() {
      return {
        projectCode: this.$t('项目编码'),
        topologyCode: this.$t('拓扑编码'),
        code: this.$t('管道编码'),
        // type: '管道类型',
        name: this.$t('管道名称'),
        height: this.$t('高程'),
        materialType: this.$t('管道材质'),
        zoomLevel: this.$t('层级')
      }
    },
  },
  methods: {
    init(row) {
      this.visible = true
      let params = {
        projectCode: row.project_code,
        topologyCode: row.topology_code,
        code: row.code,
      }
      postAction(this.url.getPipelineByCode, params).then(res => {
        if (res.success) {
          this.model = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    // 设置label
    setLabel(key) {
      return this.fieldLabels[key] || key
    },
    // 设置禁用
    setDisabled(key) {
      if (key == 'projectCode') {
        return true
      } else if (key == 'topologyCode') {
        return true
      } else if (key == 'code') {
        return true
      } else if (key == 'type') {
        return true
      } else {
        return false
      }
    },
    // 设置显示隐藏
    setIsShow(key) {
      if (this.fieldLabels[key]) {
        return true
      } else {
        return false
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleCancel() {
      this.close()
    },
    handleOk() {
      const that = this
      this.$refs.form.validate(valid => {
        if (valid) {
          that.confirmLoading = true
          postAction(this.url.updatePipeline, this.model)
            .then(res => {
              if (res.success) {
                that.$message.success(this.$t('编辑成功！'))
                that.$emit('ok')
                this.visible = false
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
            })
        }
      })
    },
  },
}
</script>